export default __webpack_public_path__ + "volvo-logo.2584de06aeec88b4588d59de1bef91e0.svg";